import React from 'react'
import { CCard, CCardBody, CBadge, CRow, CCol } from '@coreui/react-pro'

const CommunityRankingUpdateModal = ({ item }) => {
  const { payload } = item

  if (!payload || !payload.teams || payload.teams.length === 0) {
    return <p>No ranking data available</p>
  }

  const getMovementIcon = (movement_type) => {
    return movement_type === 'up' ? '▲' : '▼'
  }

  return (
    <div>
      <div style={{ textAlign: 'center', marginBottom: '20px' }}>
        <h5>Top Ranking Movements</h5>
        <p style={{ marginBottom: '10px', color: '#666' }}>{payload.description}</p>
        <CBadge color="secondary">RANKING UPDATE</CBadge>
      </div>

      <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
        {payload.teams.map((team, index) => (
          <CCard key={index} style={{ marginBottom: '15px' }}>
            <CCardBody style={{ padding: '15px' }}>
              <CRow>
                <CCol md="6">
                  <div style={{ marginBottom: '10px' }}>
                    <strong>Username:</strong> {team.full_name}
                  </div>
                  <div style={{ marginBottom: '10px' }}>
                    <strong>Team Name:</strong> {team.team_name}
                  </div>
                  <div style={{ marginBottom: '10px' }}>
                    <strong>Overall Points:</strong> {team.overall_points}
                  </div>
                </CCol>
                <CCol md="6">
                  <div style={{ marginBottom: '10px' }}>
                    <strong>Current Rank:</strong>{' '}
                    <CBadge color="info">#{team.overall_rank}</CBadge>
                  </div>
                  <div style={{ marginBottom: '10px' }}>
                    <strong>Previous Rank:</strong>{' '}
                    <CBadge color="dark">#{team.last_rank || 'N/A'}</CBadge>
                  </div>
                  <div>
                    <strong>Rank Movement:</strong>{' '}
                    <CBadge color={team.movement_type === 'up' ? 'danger' : 'success'}>
                      {getMovementIcon(team.movement_type)} {team.rank_change} Positions
                    </CBadge>
                  </div>
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>
        ))}
      </div>
    </div>
  )
}

export default CommunityRankingUpdateModal
